import React, { useState, useEffect, /*useRef*/ } from 'react';
//import { Link } from 'react-router-dom';
//import Select from 'react-select';
import { Redirect } from 'react-router-dom';

import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

import {  /*api_crud_base, api_crud_route, data_interface,*/ endpoints } from './Config';
//import ASSECCKEditor from "../../ASSEC_CKEditor/ASSEC_CKEditor";

import { getTokenInfo } from '../../../UseToken';

import Loader from '../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

import './Marcacao.css';

import {
	reqGET,
	//reqPOST,
	reqPUT,
	content_language,

} from '../../../Utils';
import Hosts from '../../../Hosts';

export default function Marcacao(props) {
	//const [, set_dados] = useState(null);
	//const dados = useRef(null);

	const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

	// const { order } = useParams();
	// const [order, set_order] = useState('0');
	const [date, setDate] = useState(new Date());

	const [encomenda, set_encomenda] = useState({});
    const [encomenda_codigo_crompra, set_encomenda_codigo_crompra] = useState('');
    const [linha_aula_encomenda, set_linha_aula_encomenda] = useState('');
    const [linha_qr, set_linha_qr] = useState('');
    const [/*id_prod*/, set_id_prod] = useState('');
    const [aula, set_aula] = useState({});
    const [encomenda_paga, set_encomenda_paga] = useState(-1);
    const [aula_ja_marcada, set_aula_ja_marcada] = useState(-1);
    const [sem_aula, set_sem_aula] = useState(-1);
    const [encomenda_qr, set_encomenda_qr] = useState([]);

	const [evento, set_evento] = useState({});
    const [codigo_compra, set_codigo_compra] = useState('');
    const [eventos, set_eventos] = useState([]);
    const [eventos_busy, set_eventos_busy] = useState([]);
    const [schedueles, setSchedueles] = useState([]);
    const [schedueles_busy, setScheduelesBusy] = useState([]);
    const [day_events, set_day_events] = useState([]);

	const [aula_type_id, set_aula_type_id] = useState('')
    const [, set_aula_type_name] = useState('')

	const aulas_types = [
		{ value: "1", label: "Ski" },
		{ value: "2", label: "Snowboard" }
	];

	const [isloading, setLoading] = useState(true);
	const [isRedirect, /*setRedirect*/] = useState(false);
	const [refresh, setRefresh] = useState(0);

	useEffect(() => { 


        console.log('props.location.state.item', props.location.state.item)
        console.log('getTokenInfo().profile', getTokenInfo().profile)

		// let operation = props.location.state.operation;
        let id = ''
        let id_prod = ''
        let qr_prod_order = ''
        if(props.location.state !== undefined && props.location.state.item !== undefined && props.location.state.item.id !== undefined) {
		    id = props.location.state.item.id;
		    id_prod = props.location.state.item.id_prod

            if(parseInt(id_prod) >= 84 && parseInt(id_prod) <= 89) {
                id_prod = 163
            }
		    qr_prod_order = props.location.state.item.order
		    set_id_prod(id_prod)
        }

        const getInfo = async (id, id_prod, qr_prod_order) => {

            await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${id}`)
                .then(res => {

					if(res.data.length > 0) {
						res.data[0].info.documento.linhas.forEach(async (el, el_k) => {

							let idp = el.id_produto
							let id_pr = el.pretence_ao_produto

                            if(parseInt(idp) >= 84 && parseInt(idp) <= 89) {
                                idp = 163
                            }

							let np = 0
							let qr_aux = []
							res.data[0].info.qr.forEach((el_qr_aux, k_qr_aux) => {
                                if(el_qr_aux.show_qr === false) {
                                    let aux_array = el_qr_aux.qr_code.split('*')

                                    // escontrar QR correcto
                                    // console.log('aux_array', aux_array)
                                    // console.log('np', np)
                                    // console.log('qr_prod_order', qr_prod_order)
                                    // console.log('aux_array[5]', aux_array[5])
                                    // console.log('aux_array[4]', aux_array[4])

									if(aux_array[4] === '1') {
    									if(parseInt(idp) === parseInt(id_prod) && parseInt(qr_prod_order) === parseInt(k_qr_aux)) {
	    									qr_aux.push(el_qr_aux)
										}
                                        else if(parseInt(id_pr) === parseInt(id_prod) && parseInt(qr_prod_order) === parseInt(k_qr_aux)) {
                                            qr_aux.push(el_qr_aux)
                                        }
									}
									else {
    									if(parseInt(idp) === parseInt(id_prod) && parseInt(np) < parseInt(aux_array[4])) {
	    									qr_aux.push(el_qr_aux)
										}
                                        else if(parseInt(id_pr) === parseInt(id_prod) && parseInt(np) < parseInt(aux_array[4])) {
                                            qr_aux.push(el_qr_aux)
                                        }
									}
									np++
								}
							})
                            // console.log('res.data[0].info.qr', res.data[0].info.qr)
                            // console.log('qr_aux', qr_aux)
                            if(qr_aux.length > 0)
    							set_encomenda_qr(qr_aux)

                            if(qr_aux.length > 0) {

                                // if(el['aula_marcada'] !== undefined && (el['aula_marcada'] === 1 || el['aula_marcada'] === '1')) {
                                if(el['quantidade_aux_em_caso_de_aula'] !== undefined && el['quantidade_aux_em_caso_de_aula'] !== null && (parseInt(el['quantidade_aux_em_caso_de_aula']) === 0)) {
                                    set_aula_ja_marcada(1)
                                }
                                else if(el['quantidade_aux_em_caso_de_aula'] !== undefined && el['quantidade_aux_em_caso_de_aula'] !== null && (parseInt(el['quantidade_aux_em_caso_de_aula']) > 0)) {
                                    set_aula_ja_marcada(0)
                                }

                                console.log('idp', idp)
                                await reqGET(`${Hosts.SIMCore_API}/estancia/aula/info/${Hosts.companycode}/${idp}`)
                                    .then(res_2 => {

                                        if(res_2.data.length > 0) {
                                            console.log('id_pr', id_pr)
                                            console.log('id_prod', id_prod)
                                            if(res_2.data[0].info.type === "aula" && id_pr === props.location.state.item.id_prod) {
                                                // console.log('el_k', el_k)
                                                // console.log('res_2.data[0', res_2.data[0])
                                                // console.log('props.location.state.item.id_prod', props.location.state.item.id_prod)
                                                // console.log('props.location.state.item.order', props.location.state.item.order)
                                                // console.log('el_k', el_k)
                                                // console.log('idp', idp)
                                                // console.log('id_pr', id_pr)
                                                console.log('el.id_produto', el.id_produto)
                                                set_encomenda_codigo_crompra(el.id_produto)
                                                set_linha_aula_encomenda(el_k)
                                                set_linha_qr(props.location.state.item.order)
                                                set_aula(res_2.data[0])
                                                set_sem_aula(1)

                                                console.log('######## res_2.data[0]', res_2.data[0])

                                                return
                                            }
                                        }

                                    })
                                    .catch(() => 404)

                            }
						})

						if(res.data[0].info.pagamento_pendente === '1' || res.data[0].info.pagamento_pendente === 1) {
							set_encomenda_paga(1)
						}

						set_encomenda(res.data[0])
					}

                })
                .catch(() => 404)

                // await reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/client/pdf`)
                // .then(res => {

                //     console.log('res pdf', res)

                // })
                // .catch(() => 404)

        }

        const get_events = async () => {

            let d1 = new Date()
            let d2 = new Date()
    
            let start = d1.getFullYear() + '-' + ((d1.getMonth() + 1) + '').padStart(2, '0') + '-' + (d1.getDate() + '').padStart(2, '0')
            d2.setMonth(d2.getMonth() + 6)
            let end = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')

            let hour = d1.getHours() + ':' + d1.getMinutes()

            // await reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/${Hosts.companycode}`)
            // await reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/available/${Hosts.companycode}/free`)
            // await reqPOST(`${Hosts.SIMCore_API}/estancia/aula/event/range/${Hosts.companycode}`, {start: start, end: end, state: 'free'})
            await reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/range/${Hosts.companycode}/${start}/${end}/free`)
                .then(async res => { 
                    // setData(res.data); 
                    // setLoading(false) 
                    // console.log(res.data)
    
                    let aux_eventos = []
                    let aux_schedueles = []
                    res.data.forEach((v) => { 
                        aux_eventos.push(v)
                        let x = aux_schedueles.filter((el) => (el.start === v.info.detail.start && el.calendarId === v.info.detail.calendarId))
                        if(x.length === 0) {
                            if(v.info.detail.start > (start + 'T' + hour)) {
                                aux_schedueles.push({
                                    id: v.id,
                                    companycode: v.info.companycode,
                                    calendarId: v.info.detail.calendarId,
                                    title: v.info.name + (v.info.instrutor.name !== '' ? ' - ' + v.info.instrutor.name : ''),
                                    category: v.info.detail.category,
                                    dueDateClass: v.info.detail.dueDateClass,
                                    start: v.info.detail.start,
                                    end: v.info.detail.end,
                                    isAllDay: v.info.detail.isAllDay,
                                    location: v.info.detail.location.name,
                                    state: v.info.detail.state,
                                    raw: v.info.detail.raw.class,
                                    isReadOnly: v.info.detail.isReadOnly
                                })
                            }
                        }
                    })
    

                    await reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/range/${Hosts.companycode}/${start}/${end}/busy`)
                        .then(res_2 => { 
            
                            res_2.data.forEach((v) => { 
                                aux_eventos.push(v)
                                let x = aux_schedueles.filter((el) => (el.start === v.info.detail.start && el.calendarId === v.info.detail.calendarId))
                                if(x.length === 0) {
                                    if(v.info.detail.start > (start + 'T' + hour)) {
                                        aux_schedueles.push({
                                            id: v.id,
                                            companycode: v.info.companycode,
                                            calendarId: v.info.detail.calendarId,
                                            title: v.info.name + (v.info.instrutor.name !== '' ? ' - ' + v.info.instrutor.name : ''),
                                            category: v.info.detail.category,
                                            dueDateClass: v.info.detail.dueDateClass,
                                            start: v.info.detail.start,
                                            end: v.info.detail.end,
                                            isAllDay: v.info.detail.isAllDay,
                                            location: v.info.detail.location.name,
                                            state: v.info.detail.state,
                                            raw: v.info.detail.raw.class,
                                            isReadOnly: v.info.detail.isReadOnly
                                        })
                                    }
                                }
                            })
            
                            // console.log(aux_schedueles)
                            set_eventos_busy(res_2.data)
                            setScheduelesBusy(aux_schedueles)
                            
                            setSchedueles(aux_schedueles)
    
                            set_eventos(aux_eventos)

                            // get_day_schedules(new Date(), aux_schedueles)


                            console.log('aux_schedueles BUSY', aux_schedueles)

                            return
                        })
                        .catch(() => 404)



                    // console.log(aux_schedueles)
                    //set_eventos(res.data)
                    // set_eventos(aux_eventos)
                    // setSchedueles(aux_schedueles)
                    setLoading(false)

                    console.log('aux_eventos', aux_eventos)
    
                    // get_day_schedules(new Date(), aux_schedueles)

                    return
                })
                .catch(() => 404)


            
        }

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        if(id !== '') {
            getInfo(id, id_prod, qr_prod_order)
            get_events()
        }

    }, [props])

	const get_day_status = (date, view) => {
        // console.log(date)
        // console.log(view)

        // console.log(schedueles)
        let x = schedueles.filter((el) => {
            const d1 = new Date(el.start);
            const d2 = new Date(date);
            if(view === "month" &&  (d1.getFullYear() === d2.getFullYear()) && (d1.getMonth() === d2.getMonth()) && (d1.getDate() === d2.getDate()))
                return el
            else if(view === "year" && (d1.getFullYear() === d2.getFullYear()) && (d1.getMonth() === d2.getMonth()))
                return el
            else if(view === "decade" &&(d1.getFullYear() === d2.getFullYear()))
                return el
            else   
                return null
        })
        if(x.length === 0)
            return true
        else
            return false
    }

    const get_day_schedules = (date, array, type_id) => {
        setDate(date)


        console.log('2314234234')

        console.log('array', array)

        set_day_events([])
        let x = array.filter((el) => {
            const d1 = new Date(el.start)
            const d2 = new Date(date)
            
            if((d1.getFullYear() === d2.getFullYear()) && (d1.getMonth() === d2.getMonth()) && (d1.getDate() === d2.getDate())) {
                if(el.calendarId === type_id)
                    return el
                else
                    return el // return null
            }
            else
                return null
        })
        set_day_events(x)

    }

    const set_type = (value, label) => {

        set_aula_type_id(value)
        set_aula_type_name(label)

        // const d2 = new Date(date)
        // let d1 = d2.getFullYear() + '-' + ((d2.getMonth() + 1) + '').padStart(2, '0') + '-' + (d2.getDate() + '').padStart(2, '0')
        get_day_schedules(date, schedueles, value)
    }

    const set_scheduele = (id) => {
        // console.log('ID', id)

        // console.log(eventos)

        let x = eventos.filter(el => el.id === id)
        if(x.length === 1) {
            let res = x.pop()

            //console.log(res)

            res.info.inscritos[0] = {
                name: '',
                age: '',
                identification_type: '',
                identification_number: '',
                codigo_compra: ''
            }

            set_evento(res)

            // Swal.fire({
            //     title: language[lang].confirm_purchase_title,
            //     text: language[lang].confirm_purchase_text,
            //     icon: 'question',
            //     showCancelButton: true,
            //     confirmButtonColor: '#0095e8',
            //     cancelButtonColor: '#d9214e',
            //     confirmButtonText: language[lang].confirm_purchase_confirm,
            //     cancelButtonText: language[lang].confirm_purchase_cancel
            // })
            // .then((result) => {
            //     if (result.isConfirmed) {
            //         reqPOST(`${Hosts.SIMCore_API}/estancia/aula/event`, res)
            //             .then(() => {     
            //                 Swal.fire(language[lang].confirm_purchase_success, '', 'info')
            //             })
            //             .catch(() => Swal.fire(language[lang].confirm_purchase_error, '', 'info'))
            //     }
            // })

        }
    }

    const save_scheduele = async () => {

        // Swal.fire('', language[lang].confirm_loader, 'info')

        Swal.fire({
            icon: "info",
            title: "",
            text: language[lang].confirm_loader,
            showConfirmButton: false
          });

        let x_qr = 0
        // encomenda.info.documento.linhas.forEach((el) => {
        encomenda.info.qr.forEach((el, k_qr) => {
            if(k_qr === linha_qr) {
                if(x_qr === 0 && el.show_qr === false) {
                    console.log('2 - x_qr', x_qr)
                    x_qr++

                    reqGET(`${Hosts.SIMCore_API}/estancia/aula/info/${Hosts.companycode}/${el['id']}`)
                        .then(async () => { 

                            evento.info.detail['state'] = 'busy';
                            evento.info.detail['calendarId'] = '0';

                            reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${encomenda.info.documento.user_info.id_user}`)
                                .then(async (res_3) => { 

                                    if(res_3.data.length > 0) {

                                        // console.log('res_3', res_3.data[0])


                                        if(evento.info.inscritos[0]['name'] === '') {

                                            evento.info.inscritos[0]['id'] = encomenda.info.documento.user_info.id_user;
                                            evento.info.inscritos[0]['age'] = res_3.data[0].info.birthday;
                                            evento.info.inscritos[0]['name'] = encomenda.info.documento.user_info.name;
                                            evento.info.inscritos[0]['id_encomenda'] = encomenda.id;
                                            evento.info.inscritos[0]['id_timestamp'] = encomenda.info.id_usado_para_gerar_pagamento;
                                            evento.info.inscritos[0]['codigo_compra'] = encomenda_codigo_crompra;
                                            evento.info.inscritos[0]['identification_type'] = '';
                                            evento.info.inscritos[0]['identification_number'] = '';
                                            evento.info.inscritos[0]['id_aula_dentro_encomenda'] = linha_aula_encomenda;

                                            evento.info.inscritos[0]['aux_qrcode'] = encomenda_qr

                                            evento.info.inscritos[0]['classe_level'] = '';

                                        }
                                        else {

                                            let event_aux = []
                                            event_aux['id'] = encomenda.info.documento.user_info.id_user;
                                            event_aux['age'] = res_3.data[0].info.birthday;
                                            event_aux['name'] = encomenda.info.documento.user_info.name;
                                            event_aux['id_encomenda'] = encomenda.id;
                                            event_aux['id_timestamp'] = encomenda.info.id_usado_para_gerar_pagamento;
                                            event_aux['codigo_compra'] = encomenda_codigo_crompra;
                                            event_aux['identification_type'] = '';
                                            event_aux['identification_number'] = '';
                                            event_aux['id_aula_dentro_encomenda'] = linha_aula_encomenda;

                                            event_aux['aux_qrcode'] = encomenda_qr

                                            event_aux['classe_level'] = '';

                                            evento.info.inscritos.push(event_aux)

                                        }

                                        console.log('evento', evento)

                                        // await reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event`, evento)
                                        await reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event/client`, evento)
                                            .then(() => {

                                                // sendMail_scheduele()

                                                /*
                                                let y = eventos.filter(el_qr => el_qr.id !== evento.id && el_qr.info.instrutor.id === evento.info.instrutor.id && ( (el_qr.info.detail.start === evento.info.detail.start) ))
                                                let y2 = eventos.filter(el_qr => el_qr.id !== evento.id && el_qr.info.instrutor.id === evento.info.instrutor.id && ( (evento.info.detail.end > el_qr.info.detail.start && evento.info.detail.end < el_qr.info.detail.end) ))
                                                let y3 = eventos.filter(el_qr => el_qr.id !== evento.id && el_qr.info.instrutor.id === evento.info.instrutor.id && ( (evento.info.detail.start > el_qr.info.detail.start && evento.info.detail.start < el_qr.info.detail.end) ))
                                                
                                                if(y.length > 0) {
                                                    y.forEach((el_cancelar) => {
                                                        reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/${Hosts.companycode}/${el_cancelar['id']}`)
                                                            .then(res_aula_2 => { 

                                                                let evento_c = res_aula_2.data[0]
                                                                evento_c.info.detail['state'] = 'cancel';
                                                                evento_c.info.detail['calendarId'] = '3';

                                                                reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event`, evento_c)
                                                                    .then(() => {

                                                                    })

                                                            })
                                                    })
                                                }
                                                if(y2.length > 0) {
                                                    y2.forEach((el_cancelar) => {
                                                        reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/${Hosts.companycode}/${el_cancelar['id']}`)
                                                            .then(res_aula_2 => { 

                                                                let evento_c = res_aula_2.data[0]
                                                                evento_c.info.detail['state'] = 'cancel';
                                                                evento_c.info.detail['calendarId'] = '3';

                                                                reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event`, evento_c)
                                                                    .then(() => {

                                                                    })

                                                            })
                                                    })
                                                }
                                                if(y3.length > 0) {
                                                    y3.forEach((el_cancelar) => {
                                                        reqGET(`${Hosts.SIMCore_API}/estancia/aula/event/${Hosts.companycode}/${el_cancelar['id']}`)
                                                            .then(res_aula_2 => { 

                                                                let evento_c = res_aula_2.data[0]
                                                                evento_c.info.detail['state'] = 'cancel';
                                                                evento_c.info.detail['calendarId'] = '3';

                                                                reqPUT(`${Hosts.SIMCore_API}/estancia/aula/event`, evento_c)
                                                                    .then(() => {

                                                                    })

                                                            })
                                                    })
                                                }
                                                */

                                                setRefresh(refresh + 1) 
                                            })
                                            .catch(() => Swal.fire('', language[lang].confirm_purchase_error, 'info'))

                                        await reqGET(`${Hosts.SIMCore_API}/store/order/payment/${Hosts.companycode}/${encomenda.info.id_usado_para_gerar_pagamento}`)
                                            .then(async (res_order) => {

                                                //console.log('res_order', res_order)

                                                if(res_order.data.length > 0) {

                                                    let x = 0
                                                    console.log(res_order.data.length)
                                                    await res_order.data[0].info.documento.linhas.forEach(async (el_linhas) => {
                                                        if(x === 0) {
                                                            if(el_linhas['quantidade_aux_em_caso_de_aula'] !== undefined && el_linhas['quantidade_aux_em_caso_de_aula'] !== null && parseInt(el_linhas['quantidade_aux_em_caso_de_aula']) > 0) {
                                                                x++

                                                                console.log('linha_qr', linha_qr)

                                                                res_order.data[0].info.qr.forEach((e_qr, k_qr) => {
                                                                    console.log('k_qr', k_qr)
                                                                    console.log('linha_qr', linha_qr)

                                                                    if(evento.info.inscritos[0].aux_qrcode.length === 1) {
                                                                        if(k_qr === linha_qr) {
                                                                            el_linhas['quantidade_aux_em_caso_de_aula'] = parseInt(el_linhas['quantidade_aux_em_caso_de_aula']) - 1
                                                                            e_qr.show_qr = true
                                                                        }
                                                                    }
                                                                    else {
                                                                        evento.info.inscritos[0].aux_qrcode.forEach(e_qr_2 => {
                                                                            if(e_qr_2.qr_code === e_qr.qr_code) {
                                                                                el_linhas['quantidade_aux_em_caso_de_aula'] = parseInt(el_linhas['quantidade_aux_em_caso_de_aula']) - 1
                                                                                e_qr.show_qr = true
                                                                            }
                                                                        })
                                                                    }
                                                                })

                                                                if(parseInt(el_linhas['quantidade_aux_em_caso_de_aula']) === 0) {
                                                                    el_linhas['aula_marcada'] = 1
                                                                }

                                                                console.log('res_order.data[0]', res_order.data[0])

                                                                await reqPUT(`${Hosts.SIMCore_API}/store/order`, res_order.data[0])
                                                                    .then(async () => {
                                                                        console.log('ORDER UPDATED', res_order.data[0])
                
                                                                        Swal.fire('', language[lang].confirm_purchase_success, 'info')

                                                                        // setRefresh(refresh + 1)

                                                                        setTimeout(() => {
                                                                            // console.log('Hello, World!')

                                                                            // props.history.push(endpoints.list) 
                                                                            props.history.push({
                                                                                pathname: 'store_order',
                                                                                state: { item: {id: props.location.state.item.id_order}, operation: 'edit' },
                                                                            });

                                                                            // window.open(Hosts.WEB_BACKOFFICE_URI, '_self')
                                                                        }, 1500);
                                                                    })
                                                                    .catch(() => console.log('error'))

                                                            }
                                                            // else {
                                                            //     el_linhas['quantidade_aux_em_caso_de_aula'] = 0
                                                            //     el_linhas['aula_marcada'] = 1
                                                            // }

                                                        }
                                                    })
                                                    
                                                }

                                            })
                                            .catch(() => console.log('error'))

                                    }

                                })
                                .catch(() => Swal.fire('', language[lang].confirm_purchase_error, 'info'))

                        })
                }

            }
        })

    }

	return isloading ?
		
		<Loader />

		:
		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:

			<main>
				<div className={`dash-cards header`}>
					<h2 className="dash-title">{language[lang].component}</h2>
					<p>{language[lang].component} / {language[lang].component_new}</p>
				</div>

				<div className={`dash-cards body`}>
					<div className="container">
						<div className="row">
		
							<div className="mb-5 mb-xl-10">
								<div className="card">

									<div className="card-body">
										<div id="aula" className="container-fluid my-5">
											<div className="row">
												<div className="container mb-3">
													<h3 className="titulo-primario">{language[lang].schedule}</h3>
													<span>Encomenda N.º {encomenda.id} {aula_ja_marcada === 1 ? '(Aula já marcada)' : ''} {encomenda_paga === 0 ? '(A aguardar pagamento)' : ''} {aula['id'] === undefined ? '(Sem aula para agendar)' : ''}</span>
												</div>

												<div className="container">
													<div className="row">

														<div className="col-12 col-md-10 mb-5">
															<div className='div-schedueles'>
																<div className='row'>
																	<div className="col-12 col-md-6">
																		<div className='calendar-container'>
																			<Calendar
																				onChange={(e) => get_day_schedules(e, schedueles, aula_type_id)} 
																				value={date} 
																				minDate={new Date()}
																				formatShortWeekday={(locale,value) => ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'][value.getDay()]}
																				//locale={lang === 'en' ? 'en-US' : (lang === 'es' ? 'es-ES' : 'pt-PT')}
																				tileDisabled={({ date, view }) => get_day_status(date, view)}
																			/>
																		</div>
																	</div>

																	<div className="col-12 col-md-6 schedueles-choose">
																		<div className=''>

																			<div className='text-center pt-3'>
																				<h3 className="subtitulo-secundario">{language[lang].schedule_choose}</h3>
																				<span className='bold'>{date.toLocaleDateString()}</span>
																			</div>

																			<div className='pt-3 pb-2'>
																				<div className='row'>
																					{aulas_types.map((el, key) => {
																						return (
																							<div key={key} className='col-6 text-center mb-2'>
																								<button className={"btn btn-scheduele text-center px-3" + (aula_type_id === el.value ? ' active' : '')} onClick={() => set_type(el.value, el.label)}>
																									{el.label}
																								</button>
																							</div>
																						)
																					})}
																				</div>
																			</div>

																			<div className='pt-3 pb-5'>
																				<div className='row'>
																					{day_events.map((el, key) => {
																						return (
																							<div key={key} className='col-6 text-center mb-2'>
																								<button className={"btn btn-scheduele text-center px-3" + (evento['id'] !== undefined && evento['id'] === el.id ? ' active' : '')} onClick={() => set_scheduele(el.id)}>
																									{el.start.split("T").pop()}h - {el.end.split("T").pop()}h
                                                                                                    {
                                                                                                    el.state === 'busy' && getTokenInfo().profile !== 'Cliente' ?
                                                                                                        <>
                                                                                                            <br />
                                                                                                            <small>({el.title.replace(' - ', '')})</small>
                                                                                                        </>
                                                                                                    :
                                                                                                        null
                                                                                                    }
																								</button>
																							</div>
																						)
																					})}
																				</div>
																			</div>

																			{
																			aula_type_id !== '' ?
																				day_events.length > 0 ?
																					evento['id'] !== undefined ?
																						<div className='row text-center mb-2'>
																							<div className="col-12 mb-3 d-none">
																								<label>{language[lang].schedule_code}</label>
																								<input type="text" name="codigo_compra" style={{width: '250px', margin: 'auto'}} className="form-control" placeholder={language[lang].schedule_code} value={codigo_compra} onChange={(e) => set_codigo_compra(e.target.value)} />
																							</div>
																							{
																							aula['id'] === undefined ?
																								null
																							:
																								encomenda_paga === 1 && aula_ja_marcada === 0 || true ?
																									<div className="col-12 mb-3">
																										<button className="btn btn-scheduele active text-center px-5" onClick={() => save_scheduele()}>{language[lang].finalize_order}</button>
																									</div> // btn btn-scheduele text-center px-3 active
																								:
																									null
																							}
																						</div>
																					:
																						null
																				:
																					<div className='text-center mb-2'>
																						<p>{language[lang].no_schedule}</p>
																					</div>
																			:
																				<div className='text-center mb-2'>
																					<p>{language[lang].choose_aula_type}</p>
																				</div>
																				
																			}

																		</div>
																	</div>

																</div>
															</div>
														</div>

													</div>
												</div> 
											</div> 
										</div>    
									</div>

								</div>
							</div>

						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
							</ul>
						</div>
					</nav>
				</div>
			</main>
}
